"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../colors"));
const select = {
    MuiSelect: {
        styleOverrides: {
            root: {
                borderRadius: "1rem",
                "&:hover": {
                    borderColor: colors_1.default.border[100],
                },
                "&.Mui-selected": {
                    background: `${colors_1.default.secondarySelected[600]} !important`,
                },
            },
            select: {
                paddingTop: "14px",
                paddingBottom: "14px",
                marginRight: "0.5rem",
                // for pagination
                minWidth: "2rem !important",
                "&.Mui-disabled": {
                    WebkitTextFillColor: colors_1.default.inputDisabled[100],
                },
            },
            icon: {
                color: colors_1.default.icons[700],
                top: "calc(50% - 10px)",
                marginRight: "0.3rem",
                "&.Mui-disabled": {
                    color: colors_1.default.inputDisabled[100],
                },
            },
        },
    },
};
exports.default = select;
